import { GetServerSideProps } from 'next';
import { Page } from '../../components/Login/RequestManager/Page';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { getDeviceSession } from '@datavant/idsb-portal-sdk/server';

interface RMLoginProps {
    autoForwarded: boolean;
}

export const getServerSideProps: GetServerSideProps<RMLoginProps> = async ({ req, res }) => {
    try {
        const deviceSession = await getDeviceSession(req, res);
        return {
            props: {
                autoForwarded: deviceSession.shouldRedirectToRMStandard ?? false,
            },
        };
    } catch {
        return {
            props: {
                autoForwarded: false,
            },
        };
    }
};

const RMLogin = ({ autoForwarded }: RMLoginProps) => {
    if (autoForwarded) {
        datadogRum.setUser({
            ...datadogRum.getUser(),
            selectedForOptOutExperimentV2: true,
        });
        datadogLogs.setUser({
            ...datadogRum.getUser(),
            selectedForOptOutExperimentV2: true,
        });
    }
    return <Page autoForwarded={autoForwarded} />;
};

export default RMLogin;
